import { useBooleanFeatureFlag } from '@confluence/session-data';

import { LIVE_PAGES_PARENT_FF } from './featureFlags';

export const useIsLivePagesFeatureEnabled = (): boolean =>
	useBooleanFeatureFlag(LIVE_PAGES_PARENT_FF);
